import './config/g_config';
import './config/private-version';

const isPrivate = window.g_config.productMode.toLowerCase().includes('private');
const env = window.g_config.env || 'online';
const libVersion = getAppVersion('isipfe/lib') || '0.0.1';
const baseVersion = getAppVersion('isipfe/base') || getAppVersion('base') || '0.1.14';
const commonVersion = getAppVersion('isipfe/xiaomi-common') || '5.1.0';
const cdn = getCDNDomain();
const basePath = isPrivate ? 'base' : 'isipfe/base';

const links = [
  `${cdn}/isipfe/lib/${libVersion}/assets/theme/base.css`,
  `${cdn}/isipfe/lib/${libVersion}/assets/theme/variable.css`,
  `${cdn}/isipfe/xiaomi-common/${commonVersion}/antd4Style.css`,
  `${cdn}/isipfe/xiaomi-common/${commonVersion}/index.css`,
  `${cdn}/${basePath}/${baseVersion}/app.css`,
];

const scripts = [
  `${cdn}/isipfe/lib/${libVersion}/assets/polyfill.min.js`,
  `${cdn}/isipfe/lib/${libVersion}/assets/lodash/4.x/lodash.min.js`,
  `${cdn}/isipfe/lib/${libVersion}/assets/react/16.14.0/react.production.min.js`,
  `${cdn}/isipfe/lib/${libVersion}/assets/react/16.14.0/react-dom.production.min.js`,
  `${cdn}/isipfe/lib/${libVersion}/assets/prop-types/15.6.1/prop-types.min.js`,
  `${cdn}/isipfe/lib/${libVersion}/assets/mount/moment-with-locales.min.js`,
  `${cdn}/isipfe/lib/${libVersion}/assets/mirrorx/0.2.10/mirror.min.js`,
  `${cdn}/isipfe/lib/${libVersion}/assets/mirrorz/4.1.1/mirrorz.js`,
  `${cdn}/isipfe/lib/${libVersion}/fall.js`,
  `${cdn}/isipfe/xiaomi-common/${commonVersion}/antd4.icons.min.js`,
  `${cdn}/isipfe/xiaomi-common/${commonVersion}/antd4.min.js`,
  `${cdn}/isipfe/lib/${libVersion}/fetcher.js`,
  `${cdn}/isipfe/xiaomi-common/${commonVersion}/index.min.js`,
  `${cdn}/${basePath}/${baseVersion}/app.js`,
];

links.forEach(loadStyle);
scripts.forEach(loadScript);

export function loadScript(url) {
  const script = document.createElement('script');
  script.src = addExtVersion(url, '.js');
  script.async = false;
  if (url.indexOf('g.alicdn.com') !== -1) {
    script.crossOrigin = true;
  }
  document.body.appendChild(script);
}

export function loadStyle(url) {
  const link = document.createElement('link');
  link.setAttribute('rel', 'stylesheet');
  link.href = addExtVersion(url, '.css');
  document.head.appendChild(link);
}

function addExtVersion(url, ext) {
  const src = url.includes(ext) ? url : `${url}${ext}`;
  return `${src}${src.includes('?') ? '&' : '?'}v=${getGlobalVersion()}`;
}

/**
 * 获取前端资源cdn路径
 * @returns {string}
 */
export function getCDNDomain() {
  if (window.g_config.cdnPath) {
    return window.g_config.productMode === 'Privateme'
      ? `${window.g_config.cdnPath}/alimefe`
      : window.g_config.cdnPath;
  }
  return {
    daily: '//g-assets.daily.taobao.net', // 不使用了
    pre: '//g.alicdn.com', // 不使用了
    preOnline: '//g.alicdn.com',
    online: '//g.alicdn.com',
    product: '/alimefe',
  }[env];
}

/**
 * 获得应用版本号
 * @param {string} appName
 * @returns
 */
export function getAppVersion(appName) {
  const app = window.g_apps[appName] || {};
  if (env === 'preOnline' || env === 'daily') {
    return app.preVersion || app.version;
  }
  // 开发环境和私有化环境base代码库中写死的版本号
  if (env === 'product' && app.productVersion) {
    return app.productVersion;
  }
  return app.version;
}

/**
 * 获取全局版本号，用于清理js缓存
 * @returns {string}
 */
export function getGlobalVersion() {
  const g = window.g_apps.global || {};
  return g.version || '0.0.1';
}



// WEBPACK FOOTER //
// ./src/entry.js